<template>
  <div class="positionfixed2">
    <!-- 头部区域 -->
    <Header></Header>

    <!-- 主体内容区域 -->
    <div class="pc_all2 LogoCenter">
      <!-- 导航栏 -->
      <!--      <div class="LogoCenterNav">-->
      <!--        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="LogoCenterNav_list font18 active">-->
      <!--          自由创作(<span>25</span>)-->
      <!--        </router-link>-->
      <!--        <router-link to="/ailogo/LogoCenter/LetterLogoCenter" class="LogoCenterNav_list font18">-->
      <!--          字母LOGO(<span>2</span>)-->
      <!--        </router-link>-->
      <!--        <router-link to="/ailogo/LogoCenter/SameCreationCenter" class="LogoCenterNav_list font18">-->
      <!--          同款创作(<span>5</span>)-->
      <!--        </router-link>-->

      <!--        <router-link to="/ailogo/LogoCenter/Downloaded"-->
      <!--          class="LogoCenterNav_list font18">已下载(<span>5</span>)</router-link>-->

      <!--      </div>-->

      <!-- 可滚动容器 -->
      <div class="LogoCenterContent OScroll" @scroll="handleLogoScroll" ref="scrollContainer">
        <!-- 列表循环 -->
        <div v-for="(site, siteIndex) in sites" :key="siteIndex"
             :class="['LogoCenterContent_list', { active: activeIndices.includes(siteIndex) }]" ref="listItems">
          <!-- 标题区域 -->
          <div class="LogoCenterTitle">
            <div class="LogoCenterTitle_bg">
              <div class="LogoCenterTitl_left">
                <div class="LogoCenterTitl_left_dd font24">
                  {{ site.title }}
                </div>
                <div class="LogoCenterTitl_left_dt">
                  <div class="left_dt_list font16" v-if="site.subtitle">{{ site.subtitle }}</div>
                  <div class="left_dt_list font16" v-if="site.keyword">{{ site.keyword }}</div>
                  <div class="left_dt_list font16" v-if="site.industry">{{ site.industry }}</div>
                  <div class="left_dt_list font16" v-if="site.style">{{ site.style }}</div>
                  <div class="left_dt_list font16" v-if="site.color">{{ site.color }}</div>
                </div>
              </div>
              <router-link to="/ailogo/EnterBrand/EnterBrand" class="LogoCenterTitl_again font16">
                <img alt="" src="@a/ailogo/images/sv4.svg"/>再来一批
              </router-link>
            </div>

            <!-- 进度条 / 图片区域 -->
            <div v-if="site.status !== 2" class="progress-container">
              <div class="progress-bar" :style="{ width: site.progress + '%' }"></div>
              <div class="progress-text">
                <div class="progress-text-left">
                  {{
                    site.status === 0
                        ? '任务启动中'
                        : site.status === 1
                            ? '生成中'
                            : '生成失败'
                  }}
                </div>
                <!-- 仅在生成中时显示旋转图标 -->
                <div v-if="site.status === 1" class="spinner"></div>
                <div v-if="site.status === 0" class="loader-inner ball-pulse">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>

          <!-- logo列表 -->
          <div class="LogoCenterContent_logo hover">
            <div v-for="(image, index) in site.logo" :key="index" class="LogoCenterContent_logo_list">

              <div class="logo_list_tag active font12" v-if="image.is_svg === 1">印刷版</div>
              <div class="logo_list_tag font12" v-else>普通版</div>

              <img :src="image.png_url" alt="站点图片" class="logo_list_img"/>
              <div class="logo_list_btn">

                <!-- 根据 is_svg 判断显示不同的链接 -->
                <div class="list_btn_list">
                  <router-link v-if="image.is_svg === 1"
                               :to="`/ailogo/GenerateManagement/LogoProperty/LogoFile?tempId=${image.id}&svg=1`"
                               class="list_btn_li font14">
                    <img alt="" src="@a/ailogo/img2/s5.svg"/>VI资产
                  </router-link>
                  <router-link v-else :to="`/ailogo/GenerateManagement/LogoProperty/LogoFile?tempId=${image.id}&svg=0`"
                               class="list_btn_li font14">
                    <img alt="" src="@a/ailogo/img2/s4.svg"/>VI资产
                  </router-link>

                  <router-link :to="`/ailogo/LogoCenter/DeepDesign?tempId=${image.id}`" target="_blank"
                               class="list_btn_li font14" v-if="image.is_svg !== 1">
                    <img alt="" src="@a/ailogo/images/sv2.svg"/>深度设计
                  </router-link>
                </div>

                <div class="list_btn_list">

                  <div v-if="image.is_svg !== 1" class="list_btn_li font14" @click="downLoadPng(image.png_url)">
                    <img alt="" src="@a/ailogo/img2/s6.svg"/>PNG下载
                  </div>
                  <div v-else class="list_btn_li font14" @click="downLoadSvg(image.svg_url)">
                    <img alt="" src="@a/ailogo/img2/s6.svg"/>矢量印刷版下载
                  </div>

                  <div class="list_btn_li font14" @click="openPaymentPopup(image.id,image.png_url)"
                       v-if="image.is_svg !== 1">
                    <img alt="" src="@a/ailogo/img2/s6.svg"/>转矢量印刷版
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- 在列表末尾插入一个小型 Loading 区域，当 isLoading=true 时显示 -->
        <div v-if="isLoading" class="loading-more-container">
          <div class="loading-more-spinner"></div>
          <div class="loading-more-text">加载中...</div>
        </div>
        <div v-else-if="currentPage >= totalPages" class="no-more-text">
          - 没有更多内容了 -
        </div>


        <!-- 物料正在打包下载中弹窗 -->
        <div class="DownloadWindow" v-show="DownloadWindow">
          <div class="DownloadWindowContent">
            <div class="DownloadWindowContent_close" @click="toggleWindows"><img alt=""
                                                                                 src="@a/ailogo/images/sv5.svg"/></div>
            <div class="DownloadWindowContent_title">物料正在打包下载中</div>
            <div class="DownloadWindowContent_icon"><span class="loader-64"> </span></div>
          </div>
        </div>


        <!-- 下载弹窗 -->
        <div class="DownloadWindow2" v-show="DownloadWindow2">
          <div class="DownloadWindowContent">
            <img alt="" src="@a/ailogo/images/bn19.png"/>
            <div class="DownloadWindowContent_close" @click="DownloadWindow2 = !DownloadWindow2"><img alt="" src="@a/ailogo/images/sv5.svg"/></div>
            <div class="DownloadWindowContent_content">
              <div class="DownloadWindowContent_content_dt">物料已经打包完成!</div>
              <div class="DownloadWindowContent_a">
                <router-link to="/ailogo/LogoCenter/Downloaded">您可在矢量印刷版列表中重复下载</router-link>
              </div>
              <div class="DownloadWindowContent_btn" @click="handleDownload">
                <span>立即下载</span>
              </div>
            </div>
            <a href="https://affim.baidu.com/unique_57216128/chat?siteId=21467967&userId=57216128&siteToken=9f9b60f596a10c1b494ba79f8f356e69&cp=&cr=&cw=AI%E5%85%AC%E5%8F%B8%E8%B5%B7%E5%90%8D%E6%95%B0%E5%AD%97%E8%B5%84%E4%BA%A7%E5%8C%85%E8%B4%AD%E4%B9%B0%E5%92%A8%E8%AF%A2" 
            target="_blank"
            class="DownloadWindowContent_btn DownloadWindowContent_btn2">
              <span>在线咨询</span>
            </a>
          </div>
        </div>
      </div>
    </div>


    <!--支付弹窗-->
    <div class="PaymentWindow" v-if="PopupWindow">
      <div class="PaymentWindowBg"></div>
      <div class="PaymentWindow_content">
        <div class="PaymentWindow_content_img"><img alt="" src="@a/ailogo/images/bg19.jpg"/></div>
        <div class="PaymentWindow_content_top">
          <div class="content_top_left"><img alt="" src="@a/img/logo.png"/></div>
          <div class="content_top_close" @click="closePaymentPopup"><img alt="" src="@a/ailogo/images/sv24.svg"/></div>
        </div>
        <div class="PaymentWindow_content_bottom">
          <div class="content_bottom_left">
            <div class="bottom_left_list">
              <div class="left_list_li top"><img alt="" :src="imagePngUrl"/></div>
              <div class="left_list_li">• 线上线下可商用</div>
              <div class="left_list_li">• 高清JPG/PNG文件</div>
              <div class="left_list_li">• 独家买断授权</div>
              <div class="left_list_li">• LOGO字体可商用</div>
              <div class="left_list_li color">• 创意商务名片/样机等</div>
              <div class="left_list_li color">• 多平台社交媒体头像</div>
              <div class="left_list_li color">• SVG矢量源文件</div>
              <div class="left_list_li color">• 高质量印刷文件</div>
              <div class="left_list_li color">• 高端VI资产下载特权</div>
            </div>
            <div class="bottom_left_list">
              <div class="left_list_li top">
                PNG</br>基础版
              </div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv21.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv21.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv21.svg"/></div>
            </div>
            <div class="bottom_left_list">
              <div class="left_list_li top">
                SVG</br>高清矢量版
              </div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
              <div class="left_list_li color"><img alt="" src="@a/ailogo/images/sv20.svg"/></div>
            </div>
          </div>
          <div class="content_bottom_right" v-for="(item, index) in payModelInfo" :key="index">
            <div class="bottom_right_dd">￥{{ item?.money }}</div>
            <div class="bottom_right_dt">{{ item?.describe }}</div>
            <div class="bottom_right_img">
              <img alt="" src="@a/ailogo/images/bn18.png"/>
              <span><img alt="" :src="item?.images"/></span>
            </div>
            <div class="bottom_right_bottom"><img alt="" src="@a/img/sv23.svg"/><img alt="" src="@a/img/sv24.svg"/>请使用支付宝/微信扫码支付
            </div>
            <div class="bottom_right_btn">
              <img alt="" src="@a/ailogo/images/sv25.svg"/>
              <a href="https://www.ai-dog.net/serviceAgreement.html" target="_blank">《用户协议》</a>
              <a href="https://www.ai-dog.net/Authorization-License-Agreement.html" target="_blank">《授权许可协议》</a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--支付弹窗-->
    <!-- <div class="DesignConcepting DesignConceptPayment" v-if="PopupWindow">
      <div class="DesignConcepting_content">
        <div class="DesignConcepting_content_title">
          <div class="content_title_logo"><img alt="" src="@a/img/logo.png" /></div>
          <div class="content_title_close" @click="closePaymentPopup">×</div>
        </div>
        <div class="DesignConceptPayment_content">
          <div class="DesignConceptPayment_content_left">
            <div class="content_left_list">
              <div class="left_list_img">
                <img :src="imagePngUrl" />
              </div>
              <div class="left_list_content">
                <div class="list_content_li">
                  <div class="content_li_dd">线上线下可商用</div>
                </div>
                <div class="list_content_li">
                  <div class="content_li_dd">高清JPG/PNG文件</div>
                </div>
                <div class="list_content_li">
                  <div class="content_li_dd">SVG/PDF矢量源文件</div>
                </div>
                <div class="list_content_li">
                  <div class="content_li_dd">精美设计理念解析</div>
                </div>
                <div class="list_content_li">
                  <div class="content_li_dd">创意商务名片/样机等</div>
                </div>
                <div class="list_content_li">
                  <div class="content_li_dd">多平台社交媒体头像</div>
                </div>
                <div class="list_content_li h">
                  <div class="content_li_dd">高品质办公必备文件</div>
                  <div class="content_li_dt">幻灯片/信头纸模板等</div>
                </div>
                <div class="list_content_li h">
                  <div class="content_li_dd">高质量印刷文件</div>
                  <div class="content_li_dt">适用产品/包装等</div>
                </div>
                <div class="list_content_li h">
                  <div class="content_li_dd">高端VI资产下载特权</div>
                  <div class="content_li_dt">全套矢量印刷文件</div>
                </div>
              </div>
            </div>
            <div class="content_left_list" v-for="(item, index) in payModelInfo" :key="index"
              :class="{ active: currentPayIndex === index }" @click="handleSelectPay(index)">
              <div class="left_list_po">限时免费</div>
              <div class="left_list_top">
                <div class="list_top_dd">{{ item?.name }}</div>
                <div class="list_top_dt">
                  ￥
                  <div class="top_dt_span">{{ item?.money }}</div>
                </div>
                <div class="list_top_p">￥{{ item?.original_price }}</div>
              </div>
              <div class="left_list_bottom">
                <div class="list_bottom_li">✓</div>
                <div class="list_bottom_li">✓</div>
                <div class="list_bottom_li">✓</div>
                <div class="list_bottom_li">✓</div>
                <div class="list_bottom_li">✓</div>
                <div class="list_bottom_li active">✗</div>
                <div class="list_bottom_li active h">✗</div>
                <div class="list_bottom_li active h">✗</div>
                <div class="list_bottom_li active h">✗</div>
              </div>
            </div>
          </div>
          <div class="DesignConceptPayment_content_right">
            <div v-for="(item, index) in payModelInfo" :key="index">
            <div class="content_right_top">
              <div class="right_top_title">专业套餐</div>
              <div class="right_top_txt">
                {{ item?.describe }}
              </div>
              <div class="right_top_tag">
                <div class="top_tag_list">LOGO字体可商用</div>
                <div class="top_tag_list">独家买断授权</div>
              </div>
            </div>
            <div class="content_right_center">
              <div class="right_center_list">
                <div class="center_list_left">商品总价</div>
                <div class="center_list_right">￥{{ item?.money }}</div>
              </div>
              <div class="right_center_list">
                <div class="center_list_left">限时折扣</div>
                <div class="center_list_right red">-￥40</div>
              </div>
              <div class="right_center_list">
                <div class="center_list_left">应付金额</div>
                <div class="center_list_right red big">
                  ￥
                  <span>{{ item?.money }}</span>
                </div>
              </div>
            </div>
            <div class="content_right_bottom">
              <div class="right_bottom_img">
                <img :src="item?.images" />
              </div>
              <div class="right_bottom_title">请用支付宝/微信扫码支付</div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <Spin size="large" fix :show="isPayLoading"></Spin>
    </div> -->
  </div>
</template>

<script>
import Header from '@c/header/header'
import {svgDownload} from "@/utils/download";
// import ImageModal from '@c/common/ImageModal/ImageModal.vue' // 未使用

export default {
  name: 'LogoCenter',
  components: {
    Header
    // ImageModal,
  },
  data() {
    return {
      // 弹窗相关
      isActive: false,
      PopupWindow: false,
      ExampleWindowActive: false,
      DownloadWindow: false,
      DownloadWindow2: false,

      // 输入焦点管理
      brandInputs: [
        {value: '', focused: false},
        {value: '', focused: false}
      ],

      // 行业 / 风格 / 颜色等基础数据
      industries: [
        '餐饮美食', '美容美发', '健康养生', '教育培训', '文体娱乐', '母婴保育', '箱包服饰',
        '家居建材', '萌宠服务', '商品零售', '旅游住宿', '汽车服务', '房地产', '科研服务',
        '生产制造', '企业服务', '农业服务', '公益环保', '政务组织', '生活服务'
      ],
      activeIndustry: 0,

      styles: ['现代简约', '几何线形', '吉祥物', '美式徽章'],
      activeStyle: 0,

      colors: ['red', 'blue', 'green', 'blue', 'green', 'blue', 'green'],
      activeColor: null,
      otherColorInput: '',

      // 关键词相关
      keywordInput: '',
      charCount: 0,
      keywords: ['老鼠', '染色体', '药物', '科研', '试用药', 'DNA'],
      activeKeywords: [],

      // 列表与分页
      sites: [],         // 列表数据
      activeIndices: [], // 跟踪所有触碰顶部的元素索引(如果有需要才用)
      currentPage: 1,    // 当前加载的页码
      pageSize: 3,       // 每页加载数量
      totalPages: 0,     // 总页数
      isLoading: false,  // 防止重复加载
      intervalId: null,  // 轮询 ID

      payModelInfo: [], // 支付列表数据
      currentPayIndex: null, // 当前选中支付项的索引
      currentPayInfo: null, // 当前选中支付项的信息

      pollingTimer: null, // 支付弹窗 订单轮询 定时器 ID
      imageIdToPrint: null, // 存储待转SVG印刷版的图片 ID
      imagePngUrl: null, // 存储待转SVG印刷版的图片 URL

    }
  },
  created() {
    this.getImages(); // 初次加载第一页数据
  },
  mounted() {
    // 注意：不再监听 window 滚动
    // this.handleLogoScroll 会在 .LogoCenterContent 的 @scroll 中调用
    this.getPayModelInfo(); // 页面加载时获取支付列表数据
  },
  beforeDestroy() {
    // 组件销毁时停止轮询
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.stopPaymentPolling(); // 页面销毁时停止轮询
  },
  methods: {
    toggleWindows() {
      this.DownloadWindow = !this.DownloadWindow;
      this.DownloadWindow2 = !this.DownloadWindow2;
    },
    /** 1. 滚动到容器底部时触发加载更多 */
    handleLogoScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      // 到达底部 => 加载更多
      if (
          scrollTop + clientHeight >= scrollHeight - 10 &&
          !this.isLoading &&
          this.currentPage < this.totalPages
      ) {
        // 这里请求下一页
        this.getImages(this.currentPage + 1, this.pageSize);
      }

      // 检测列表项是否触碰顶部
      const containerTop = container.getBoundingClientRect().top;
      this.activeIndices = [];
      this.$refs.listItems.forEach((item, index) => {
        const itemTop = item.getBoundingClientRect().top - 100;
        if (itemTop <= containerTop) {
          if (!this.activeIndices.includes(index)) {
            this.activeIndices.push(index);
          }
        }
      });
    },

    /** 2. 切换再来一批弹窗 */
    toggleClass() {
      this.isActive = !this.isActive;
    },

    /** 3. 切换更多关键词示例弹窗 */
    ExampleWindowClass() {
      this.ExampleWindowActive = !this.ExampleWindowActive;
    },

    /** 4. 输入框聚焦/失焦相关 */
    handleFocus(index) {
      this.brandInputs[index].focused = true;
    },
    handleBlur(index) {
      this.brandInputs[index].focused = false;
    },
    isInputFocused(index) {
      return this.brandInputs[index].focused;
    },
    isInputWithContent(index) {
      return this.brandInputs[index].value.trim() !== '';
    },

    /** 5. 关键词逻辑 */
    updateCharCount() {
      this.charCount = this.keywordInput.length;
      if (this.charCount > 150) {
        this.keywordInput = this.keywordInput.slice(0, 150);
      }
    },
    clearInput() {
      this.keywordInput = '';
      this.charCount = 0;
      this.activeKeywords = [];
    },
    toggleKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((k) => k.trim());
      const keywordIndex = keywordsArray.indexOf(item);

      if (keywordIndex !== -1) {
        // Remove item from textarea
        this.removeKeyword(item);
      } else {
        // Add item to textarea
        this.addKeyword(item);
      }
      this.updateCharCount();
    },
    addKeyword(item) {
      if (this.keywordInput) {
        this.keywordInput += `, ${item}`;
      } else {
        this.keywordInput = item;
      }
      this.activeKeywords.push(item);
    },
    removeKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((k) => k.trim());
      const keywordIndex = keywordsArray.indexOf(item);

      keywordsArray.splice(keywordIndex, 1);
      this.keywordInput = keywordsArray.join(', ');
      this.activeKeywords = this.activeKeywords.filter((kw) => kw !== item);
    },

    /** 6. 行业 / 风格 / 颜色选择 */
    selectIndustry(index) {
      this.activeIndustry = index;
    },
    selectStyle(index) {
      this.activeStyle = index;
    },
    selectColor(index) {
      this.activeColor = index;
      this.otherColorInput = '';
    },
    handleOtherColorInput() {
      if (this.otherColorInput) {
        this.activeColor = null;
      }
    },

    /** 7. 数据获取与轮询进度 */
    async getImages(page = 1, limit = 3) {
      try {
        this.isLoading = true; // 开始“加载更多”，显示底部 Loading
        const res = await this.axios.get(
            "https://api.ai-dog.net/api/LogoChoice/historyList",
            {params: {page, limit}}
        );

        if (res.code === 1) {
          const {data, current_page, last_page} = res.result;
          this.currentPage = current_page;
          this.totalPages = last_page;

          // 追加新数据
          this.sites = [
            ...this.sites,
            ...data.map(site => ({
              ...site,
              progress: site.status === 1 ? 1 : 1
            }))
          ];

          // 检查是否需要轮询
          const needsPolling = this.sites.some(site => site.status !== 2);
          if (needsPolling && !this.intervalId) {
            this.startPolling();
          }
        } else {
          console.error("接口返回错误:", res.msg);
        }
      } catch (error) {
        console.error("获取站点时出错:", error.message);
      } finally {
        this.isLoading = false; // 结束“加载更多”，隐藏底部 Loading
      }
    },

    startPolling() {
      this.intervalId = setInterval(async () => {
        try {
          const res = await this.axios.get(
              'https://api.ai-dog.net/api/LogoChoice/historyList',
              {params: {page: 1, limit: this.sites.length}}
          );
          if (res.code === 1) {
            // 更新每一项的状态/进度
            res.result.data.forEach(async (site, index) => {
              if (site.status !== this.sites[index].status) {
                this.sites[index].status = site.status;
                this.sites[index].logo = site.logo;
              }

              // 如果是生成中，则获取实时进度
              if (site.status === 1) {
                try {
                  const progressRes = await this.axios.get(
                      'https://api.ai-dog.net/api/LogoChoice/getProgress',
                      {params: {unique_id: site.unique_id}}
                  );
                  if (progressRes.code === 1) {
                    const {generated, img_num} = progressRes.result;
                    const progress = (generated / img_num) * 100;
                    if (this.sites[index].progress < progress) {
                      this.sites[index].progress = progress;
                    }
                  } else {
                    console.error('获取进度失败:', progressRes.msg);
                  }
                } catch (error) {
                  console.error('请求进度时出错:', error.message);
                }
              }
            });

            // 如果所有任务都已完成，就停止轮询
            if (this.sites.every((site) => site.status === 2)) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          } else {
            console.error('轮询接口返回错误:', res.msg);
          }
        } catch (error) {
          console.error('轮询请求出错:', error.message);
        }
      }, 5000); // 每 5 秒轮询一次
    },

    async getPayModelInfo() {
      try {
        const res = await this.axios.get(`api/products/getLogoEditorList`);
        if (res.code === 1) {
          this.payModelInfo = res.result;
          console.log("支付列表数据:", this.payModelInfo);
        } else {
          console.error("接口返回错误:", res);
        }
      } catch (error) {
        console.error("获取支付列表时出错:", error);
      }
    },
    handleSelectPay(index) {
      this.currentPayIndex = index;
      this.currentPayInfo = this.payModelInfo[index];
      console.log("选中支付项:", this.currentPayInfo);
    },

    // 打开支付弹窗并开始轮询
    openPaymentPopup(imageId, imageUrl) {
      this.imageIdToPrint = imageId; // 存储图片ID
      this.imagePngUrl = imageUrl; // 存储图片URL
      this.PopupWindow = true;
      this.startPaymentPolling();
    },
    // 关闭支付弹窗并停止轮询
    closePaymentPopup() {
      this.PopupWindow = false;
      this.stopPaymentPolling();
    },
    // 开始轮询接口
    startPaymentPolling() {
      this.pollingTimer = setInterval(async () => {
        try {
          const res = await this.axios.get(`api/pointOrder/hasNewOrder`);
          if (res.code === 1 && res.result === true) {
            this.handlePaymentSuccess();
          } else {
            console.log("支付未完成，继续轮询...");
          }
        } catch (error) {
          console.error("轮询接口出错:", error);
        }
      }, 2000); // 每 3 秒轮询一次
    },

    // 停止轮询
    stopPaymentPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },

    // 支付成功处理
    handlePaymentSuccess() {

      this.stopPaymentPolling(); // 停止轮询
      this.PopupWindow = false; // 关闭弹窗
      this.DownloadWindow = true; // 执行物料下载弹窗
      // alert("支付成功！");

      // 支付成功后，调用接口生成SVG印刷版
      this.createSvgPrint(this.imageIdToPrint);

    },

    // 调用接口生成SVG印刷版
    async createSvgPrint(imageId) {
      try {
        const res = await this.axios.post(`api/LogoChoice/createSvgPrint`, {imageId});
        if (res.code === 1) {
          console.log("SVG 印刷版生成成功");

          const newImageId = res.result.image_id;

          const downloadRes = await this.axios.post(`api/LogoChoice/downloadResource`, {imageId: newImageId});
          if (downloadRes.code === 1 && downloadRes.result && downloadRes.result.downloadUrl) {
            this.downloadUrl = downloadRes.result.downloadUrl;

            this.DownloadWindow = false; // 关闭物料弹窗
            this.DownloadWindow2 = true; // 执行打包下载弹窗
            // alert("打包成功！");
          } else {
            console.error("获取下载链接失败:", downloadRes.msg);
          }
        } else {
          console.error("生成 SVG 印刷版失败:", res.msg);
        }
      } catch (error) {
        console.error("生成 SVG 印刷版时出错:", error);
      }
    },
    handleDownload() {
      if (this.downloadUrl) {
        this.downLoadSvg(this.downloadUrl);
      }
    },

    //png下载
    downLoadPng(url) {
      fetch(url, { mode: 'cors' })
        .then(response => response.blob())
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = url.split('/').pop() || 'download.png';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl); // 清理内存
        })
        .catch(error => {
          console.error('下载失败:', error);
          alert('文件下载失败');
        });
    },

    //svg下载
    async downLoadSvg(baseUrl) {
      try {
        if (!baseUrl.includes("logo.svg"))
          baseUrl += "/logo.svg";
        // 获取原始 SVG 图片的 URL
        const originalSvg = await this.axios.get(baseUrl , {
          responseType: "text",
          withCredentials: false
        },);
        // 创建一个 Fabric.js Canvas 实例
        svgDownload(originalSvg, "ailogo");

      } catch (error) {
        console.error("加载或处理 SVG 图片失败:", error);
      }
    },


  },
};
</script>

<style>
@import "LogoCenter.css";
</style>
